export const USER_ROLES={
    USER:"user",
    ADMIN:"admin"
}
export const cRegion = "us-east-1";
export const TOKEN = "access-token"
export const REFRESH_TOKEN = "refresh-token"
export const USER_ID = "user_id"
export const USER_GROUPS = "user_groups"
export const USER_DATA = "user_data"
export const PERMISSIONS = "user_permissions"
export const drawerWidth = 300